import { Anchor, AppShell, Burger, Group, Image, Text, em } from "@mantine/core";
import MainArea from "./components/MainArea";
import Side from "./components/Side";
import { useDisclosure } from "@mantine/hooks";
import "./HomePage.css";
import { useMediaQuery } from '@mantine/hooks';

const logoUrl = "https://img.icons8.com/external-others-phat-plus/64/000000/external-bell-hotel-and-travel-color-line-others-phat-plus.png";

const HomePage = () => {
    const [opened, { toggle }] = useDisclosure();

    const isMobile = useMediaQuery(`(max-width: ${em(750)})`);

    return(
        <AppShell
            header={{ height: 60 }}
            navbar={{ width: 300, breakpoint: 'sm', collapsed: { mobile: !opened } }}
            padding="md"
        >
            <AppShell.Header>
                <div className="header-box">
                    <Group justify="flex-start" align="center">
                        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
                        <Group>
                            <Image src={ logoUrl } w={30} />
                            <Text fw={600}>NowCheckin</Text>
                        </Group>
                    </Group>
                </div>
            </AppShell.Header>

            <AppShell.Navbar p="md">
                <Side onItemPressed={ toggle } />
            </AppShell.Navbar>

            <AppShell.Main  style={{ backgroundColor: "whitesmoke" }}>
                <MainArea />
            </AppShell.Main>

            <AppShell.Footer>
                <div className="footer-content">
                    <div style={{ width: '300px', display: isMobile ? 'none' : 'block' }}></div>
                    
                    <div className="footer-info">
                        <Group justify="center">
                            <Text style={{ opacity: .5 }}>© 2024 -</Text>
                            <Anchor href="https://eu-cental-1-nowcheckin-public.s3.eu-central-1.amazonaws.com/Termini-e-Condizioni-Sito-Web-o-App.html" target="_blank">
                                Termini di utilizzo
                            </Anchor>
                            <Anchor href="https://eu-cental-1-nowcheckin-public.s3.eu-central-1.amazonaws.com/Privacy-Policy-sul-Trattamento-dei-Dati.html" target="_blank">
                                Informativa Privacy
                            </Anchor>
                            <Anchor href="https://eu-cental-1-nowcheckin-public.s3.eu-central-1.amazonaws.com/Cookie-Policy.html" target="_blank">
                                Informativa Cookie
                            </Anchor>
                        </Group>
                    </div>
                </div>
            </AppShell.Footer>
        </AppShell>
    );
};

export default HomePage;